"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loggerLink = void 0;
var client_1 = require("@trpc/client");
/**
 * Logger middleware for @trpc/client that will automatically log information
 * about every request. This can be used to debug the requests being made in your apps.
 */
function loggerLink(options) {
    var enabled = options.enabled, logger = options.logger;
    return function (_runtime) {
        return function (_a) {
            var next = _a.next, op = _a.op, prev = _a.prev;
            var start = Date.now();
            next(op, function (result) {
                // Link is disabled, so bail
                if (!enabled) {
                    prev(result);
                    return;
                }
                var duration = Date.now() - start;
                if (result instanceof client_1.TRPCClientError) {
                    logger.info('Request failed', result);
                }
                else {
                    logger.info("Request completed in ".concat(duration, "ms"), result);
                }
                prev(result);
            });
        };
    };
}
exports.loggerLink = loggerLink;
